import React from 'react';
import classNames from 'classnames';
import useTranslations from '@/hooks/translations';
import Text from '../../../app/Text';
import Faq from './Faq';
import styles from './styles';

export default function FaqList({
  isCelebritieLandingPage,
  isUsedInYourPlan,
  isNoTrial,
}) {
  const { t } = useTranslations();
  const faqs = [
    {
      question: 'payment_subscribe_faq_list_item_question1',
      answer: 'payment_subscribe_faq_list_item_answer1',
    },
    {
      question: 'payment_subscribe_faq_list_item_question2',
      answer: 'payment_subscribe_faq_list_item_answer2',
    },
    {
      question: 'payment_subscribe_faq_list_item_question3',
      answer: 'payment_subscribe_faq_list_item_answer3',
    },
    {
      question: 'payment_subscribe_faq_list_item_question4',
      // The standard answer promises a trial reminder 2 days before the trial
      // ends. auraWebPaywallNoTrialPlans arms 'a' and 'c' have no trial and no
      // reminder is ever sent, so that sentence is dropped for them — on the
      // screen a visitor reads right before being charged in full. The refund
      // promise before it stays: it is still true, and matters more when the
      // card is charged up front. The question is unchanged either way, since
      // the subscription auto-renews and forgetting to cancel is still real.
      answer: isNoTrial
        ? 'payment_subscribe_faq_list_item_answer4_no_trial'
        : 'payment_subscribe_faq_list_item_answer4',
    },
  ];
  return (
    <div className="col align-center w-100">
      <div
        className={classNames('container w-100', {
          'your-plan-top-margin': isUsedInYourPlan,
        })}>
        {!isCelebritieLandingPage && (
          <Text
            type="h4"
            color="b100"
            style={
              isUsedInYourPlan
                ? {
                    fontSize: '20px',
                    marginBottom: 12,
                    lineHeight: '25px',
                    fontWeight: '600',
                  }
                : { marginBottom: 12 }
            }>
            {t(
              isUsedInYourPlan
                ? 'payment_subscribe_faq_header_text_exp'
                : 'payment_subscribe_faq_header_text'
            )}
          </Text>
        )}
        {faqs.map((i) => (
          <Faq
            key={i.question}
            item={i}
            chageColorOnOpen={!isCelebritieLandingPage}
          />
        ))}
      </div>

      <style jsx>{styles}</style>
    </div>
  );
}
